module.exports = __webpack_public_path__ + "img/oti_4.0595dd50.jpg";